// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__X0HNo","colCheckbox":"styles_colCheckbox__Hd1yf"};